import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { NeurodiversitySearcherInfo } from '@lyrahealth-inc/shared-app-logic/src/features/centerOfExcellence/types'

import { CLEAR_NEURODIVERSITY_SEARCHER_INFO, SET_NEURODIVERSITY_SEARCHER_INFO } from './centerOfExcellenceActions'

const initialState = fromJS({
  neurodiversitySearcherInfo: null,
})

export default createReducer(initialState, {
  [SET_NEURODIVERSITY_SEARCHER_INFO]: ($$state: $TSFixMe, action: { value: NeurodiversitySearcherInfo }) => {
    $$state = $$state.set('neurodiversitySearcherInfo', fromJS(action.value))
    return $$state
  },
  [CLEAR_NEURODIVERSITY_SEARCHER_INFO]: ($$state: $TSFixMe) => {
    $$state = $$state.set('neurodiversitySearcherInfo', initialState.get('neurodiversitySearcherInfo'))
    return $$state
  },
})
